import { useFiltersContext } from '@/context'
import { DashboardQueries } from '@/graphql/queries/dashboard.queries'
import { ScheduledCommunicationSectionData } from '@/types/Dashboard'

import { useGraphql } from '../useGraphql'

const useScheduledCommunicationsSection = () => {
  const [{ marketSegmentFilter }] = useFiltersContext()
  const { marketSegmentIds } = marketSegmentFilter
  const scheduledCommunicationQuery = useGraphql<{ agmDashboard: ScheduledCommunicationSectionData }>(
    DashboardQueries.QUERY_KEYS.getScheduledCommunicationsSection,
    DashboardQueries.getScheduledCommunicationsSection(),
    {
      marketSegmentIds: marketSegmentIds,
    },
    {
      enabled: !!marketSegmentIds,
    },
  )

  return scheduledCommunicationQuery
}

export default useScheduledCommunicationsSection
